import { render } from "./UserVisitLogView.vue?vue&type=template&id=473ea462&scoped=true"
import script from "./UserVisitLogView.vue?vue&type=script&lang=js"
export * from "./UserVisitLogView.vue?vue&type=script&lang=js"

import "./UserVisitLogView.vue?vue&type=style&index=0&id=473ea462&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473ea462"]])

export default __exports__